export const DateProperty = ({ value }) => {

    const localDate = new Date(value).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
    });

    return (
        <span>{localDate}</span>
    );
}